import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { MaximumCategory } from '../models/maximumcategory';
import { AttributeHeaders } from '../models/attributeheaders';
import { AttributesKeys } from '../models/attributekeys';
import { ConfigMaxSetData } from '../models/configmaxsetdata';
import { CategoriesRecord } from '../models/categoriesrecord';
import { ConfigMaxSet } from '../models/configmaxset';
import { ConfigMaxSetAttributes } from '../models/configmaxsetattributes';
import { ConfigMaxSetAttrAuthors } from '../models/configmaxsetattrauthors';
import { AuthHttp } from 'angular2-jwt';
import { NumberConstants } from "../common/numberconstants";
import { EnvironmentsService } from 'app/services/enviornment.service';
import { PublishAttributesRequest } from 'app/models/publishattributesreq';
import { ReportsService } from 'app/services';


@Injectable()
export class LimitsService {

  constructor(private authhttp: AuthHttp, private http: Http, private numberconstants: NumberConstants, private envService: EnvironmentsService, private reportService: ReportsService) {
  }

  addHeaders(header: AttributeHeaders, vmwProductId: any, releaseId: any): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let attrHeaderUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + vmwProductId + "/releases/" + releaseId +
      "/categories/" + header.categoryId + "/subcategories/" + header.subCategoryId + "/attributeheaders";
    return this.authhttp.post(attrHeaderUrl,
      JSON.stringify(header), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let created = response.json();
        return created;
      });
  }

  addUpdateConfigs(config: ConfigMaxSetAttributes): Observable<any> {
    let headers = new Headers();
    let configs: Array<ConfigMaxSetAttributes> = [config];
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + config.productId + "/releases/" + config.versionId +
      "/categories/" + config.categoryId + "/subcategories/" + config.subcategoryId + "/attributes";
    let requestType: string = config["type"];
    if (requestType === "Add") {
      return this.authhttp.post(maximumUrl,
        JSON.stringify(configs), { headers: headers })
        .map((response: Response) => {
          let created = response.json();
          return created;
        });
    } else {
      return this.authhttp.put(maximumUrl,
        JSON.stringify(configs), { headers: headers, withCredentials: true })
        .map((response: Response) => {
          let updated = response.json();
          return updated;
        });
    }

  }
  getHeaders(catId: any, subCatId: any, vmwProductId: any, releaseId: any): Observable<any> {
    let attrHeaderUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + vmwProductId + "/releases/" + releaseId +
      "/categories/" + catId + "/subcategories/" + subCatId + "/attributeheaders";
    return this.authhttp.get(attrHeaderUrl, { withCredentials: true })
      .map((response: Response) => {
        let headers = response.json();
        return headers;
      });
  }
  getAttrKeys(vmwProductId: number): Observable<AttributesKeys[]> {
    let attrKeysUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + vmwProductId + "/categories/attributekeys";
    return this.authhttp.get(attrKeysUrl, { withCredentials: true })
      .map((response: Response) => {
        let keys = response.json();
        return keys;
      });
  }

  updateConfigmaxset(configmaxset: ConfigMaxSet): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let configSeturl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/" + configmaxset.vmwProductId + "/releases/" + configmaxset.vmwProductReleaseId.join() + "/configmaxset";
    return this.authhttp.put(configSeturl,
      JSON.stringify(configmaxset), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let created = response.json();
        return created;
      });

  }

  postConfigmaxSet(prodId: number, versionId: number): Observable<any> {
    let configSetUrl = this.envService.config.espApiLimits +
      "limits/menutree/v1/vmwareproducts/" + prodId + "/releases/" + versionId + "/configmaxset"
    return this.authhttp.get(configSetUrl, { withCredentials: true })
      .map((response: Response) => {
        let config = response.json();
        return config;
      });
  }

  deleteConfigurations(config: ConfigMaxSetAttributes): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let configs: Array<ConfigMaxSetAttributes> = [config];
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + config.productId + "/releases/" + config.versionId +
      "/categories/" + config.categoryId + "/subcategories/" + config.subcategoryId + "/attributes";
    let options = {
      headers: headers,
      body: JSON.stringify(configs),
      withCredentials: true
    };
    return this.authhttp.delete(maximumUrl, options)
      .map((response: Response) => {
        let result = response.json();
        return result;
      });
  }

  assignTeamMember(id: number, email: any, userType: any, user: String): Observable<any> {
    let assignEmailEndPoint = this.envService.config.espApiLimits +
      "limits/managelimits/v1/configmaxset/attribute/" + id + "/assignuser/";
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let mail = {
      'assigneEmail': email,
      "userType": userType,
      "updatedBy": user,
      "lastUpdate": new Date()
    };
    return this.authhttp.post(assignEmailEndPoint, JSON.stringify(mail), { headers: headers, withCredentials: true }).map((response: Response) => {
      let status = response.json();
      return status;
    });
  }

  getAttrAuthors(attrId: String): Observable<ConfigMaxSetAttrAuthors[]> {
    let authorRevisionsUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/attributes/" + attrId + "/authorrevisions";
    return this.authhttp.get(authorRevisionsUrl, { withCredentials: true })
      .map((response: Response) => {
        let authorRevisions = response.json();
        return authorRevisions;
      });
  }

  updateAttrAuthors(attrId: number, authortypeId: number, desc: String, authorName: String): Observable<any> {
    let authorRevisionsUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/attributes/" + attrId + "/authorrevisions";
    let authorRevision: ConfigMaxSetAttrAuthors = new ConfigMaxSetAttrAuthors();
    authorRevision.authorTypeId = authortypeId;
    authorRevision.configMaxSetAttrId = attrId;
    authorRevision.authorName = authorName;
    authorRevision.description = desc;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.authhttp.post(authorRevisionsUrl, JSON.stringify(authorRevision), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let data = response.json();
        return data;
      });
  }

  updateConfigAttributes(attributes: any, prodId: number, releaseId: number): Observable<any> {
    let attrObj: ConfigMaxSetData = new ConfigMaxSetData();
    attrObj.configs = attributes;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + prodId + "/releases/" + releaseId + "/categories/attributes";
    return this.authhttp.put(maximumUrl,
      JSON.stringify(attrObj), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let data = response.json();
        return data;
      });
  }

  updateAllConfigAttributes(prodId: number, relId: number, publishType: number, page: number, size: number): Observable<any> {
    let publishReq: PublishAttributesRequest = new PublishAttributesRequest();
    publishReq.prodId = prodId;
    publishReq.relId = relId;
    publishReq.publishType = publishType;
    publishReq.page = page;
    publishReq.size = size;
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + prodId + "/releases/" + relId + "/attributes";
    return this.authhttp.put(maximumUrl,
      { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let data = response.json();
        return data;
      });
  }

  getConfigMaximums(categories: CategoriesRecord,
    pageIndex: number, pageSize: number, showAll: boolean, isTotalCount: boolean): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + categories.prodId + "/releases/" + categories.relId + "/categories/attributes";
    let requestParams = "?";
    if (pageSize !== this.numberconstants.ZERO) {
      requestParams += "page=" + pageIndex + "&size=" + pageSize;
    }
    if (showAll === false) {
      if (requestParams !== "?") {
        requestParams += "&";
      }
      requestParams += "showall=" + showAll;
    }
    if (requestParams !== "?") {
      requestParams += "&";
    }
    requestParams += "isTotalCount=" + isTotalCount;

    if (requestParams !== "?") {
      maximumUrl = maximumUrl + requestParams;
    }
    maximumUrl = maximumUrl + ""
    let token: any = localStorage.getItem("token");
    if (token == undefined || token == null) {
      return this.http.post(maximumUrl, JSON.stringify(categories), { headers: headers, withCredentials: true }
      ).map((response: Response) => {
        return response;
      });
    } else {
      return this.authhttp.post(maximumUrl, JSON.stringify(categories), { headers: headers, withCredentials: true }
      ).map((response: Response) => {
        return response;
      });
    }
  }

  bulkdeleteConfigurations(configs: any): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + configs[this.numberconstants.ZERO].productId + "/releases/" + configs[this.numberconstants.ZERO].versionId +
      "/categories/" + configs[this.numberconstants.ZERO].categoryId + "/subcategories/" + configs[this.numberconstants.ZERO].subcategoryId + "/attributes";
    let options = {
      headers: headers,
      body: JSON.stringify(configs),
      withCredentials: true
    };
    return this.authhttp.delete(maximumUrl, options)
      .map((response: Response) => {
        let result = response.json();
        return result;
      });
  }

  bulkapproveConfigurations(configs: any): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + configs[this.numberconstants.ZERO].productId + "/releases/" + configs[this.numberconstants.ZERO].versionId +
      "/categories/" + configs[this.numberconstants.ZERO].categoryId + "/subcategories/" + configs[this.numberconstants.ZERO].subcategoryId + "/attributes";
    return this.authhttp.put(maximumUrl,
      JSON.stringify(configs), { headers: headers, withCredentials: true })
      .map((response: Response) => {
        let created = response.json();
        return created;
      });
  }

  public updateCategory(category: MaximumCategory): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumCategoryUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + category.cmVmwProductId + "/releases/" + category.cmVmwProdRelId + "/categories";
    return this.authhttp.put(maximumCategoryUrl,
      JSON.stringify(category), { headers: headers, withCredentials: true }).
      map((response: Response) => {
        let catRes = response.json();
        return catRes;
      });
  }

  deleteCategory(category: any): any {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let maximumCategoryUrl = this.envService.config.espApiLimits +
      "limits/managelimits/v1/vmwareproducts/" + category.cmVmwProductId + "/releases/" + category.cmVmwProdRelId + "/categories";
    let options = {
      headers: headers,
      body: JSON.stringify(category),
      withCredentials: true
    };
    return this.authhttp.delete(maximumCategoryUrl, options)
      .map((response: Response) => {
        let result = response.json();
        return result;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/limits/limits.service.ts